import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';
import { Wave } from './DecorativeShapes';
export const ContactSection = () => {
  return <section id="contact" className="w-full bg-slate-900 text-white relative overflow-hidden" data-id="element-6">
      {/* Top Wave Divider */}
      <div className="absolute top-0 left-0 w-full text-sand-200 rotate-180" data-id="element-7">
        <Wave className="w-full h-8 md:h-16" data-id="element-8" />
      </div>

      <div className="max-w-4xl mx-auto px-6 py-32 md:py-40 text-center relative z-10" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-10">
          <div className="w-20 h-20 bg-coral-600 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-coral-600/20" data-id="element-11">
            <Phone size={36} className="text-white" data-id="element-12" />
          </div>

          <h2 className="font-display text-4xl md:text-6xl mb-6" data-id="element-13">
            Let's Make a Deal
          </h2>
          <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-14">
            Ready to squeeze the potential out of this domain? Contact José
            directly to discuss pricing or the web page bundle.
          </p>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto" data-id="element-15">
            <p className="text-slate-400 mb-2 uppercase tracking-widest text-sm font-semibold" data-id="element-16">
              Call or Text José
            </p>
            <a href="tel:305-877-9092" className="inline-block font-display text-5xl md:text-7xl text-citrus-400 hover:text-citrus-300 transition-colors mb-8 drop-shadow-md" data-id="element-17">
              305-877-9092
            </a>

            <br data-id="element-18" />

            <a href="tel:305-877-9092" className="inline-flex items-center justify-center gap-2 bg-coral-600 hover:bg-coral-500 text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105 active:scale-95 shadow-xl shadow-coral-600/30" data-id="element-19">
              <Phone size={20} data-id="element-20" />
              Call Now
              <ArrowRight size={20} className="ml-1" data-id="element-21" />
            </a>
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-coral-900 rounded-full blur-[100px] opacity-50 pointer-events-none" data-id="element-22"></div>
      <div className="absolute top-20 -right-20 w-72 h-72 bg-ocean-700 rounded-full blur-[100px] opacity-30 pointer-events-none" data-id="element-23"></div>
    </section>;
};